import { render, staticRenderFns } from "./Login-Verify.vue?vue&type=template&id=fedd10ba"
import script from "./Login-Verify.vue?vue&type=script&lang=js"
export * from "./Login-Verify.vue?vue&type=script&lang=js"
import style0 from "./Login-Verify.vue?vue&type=style&index=0&id=fedd10ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports